import { Heading, Button as ButtonC, Spacer, useToast, VStack, Link } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Location, useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeProvider';
import { Text } from '../../../components/atoms/Text';
import { Input } from '../../../components/atoms/Input';
import { Button } from '../../../components/atoms/Button';

import { Footer } from '../../../components/organisms/Footer';
import { SectionTitle } from '@/components/atoms/Title';
import { useProfile } from '@/contexts/ProfileProvider';
import { useLoginExClient } from '@/service/auth/hooks';
import { masks } from '@/utils/masks';
import { validarCPF, validarCNPJ } from '@/utils/validateDocuments';

export function LoginExCliente({ setExClient }: { setExClient?: (value: boolean) => void }) {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast({ isClosable: true });
  const { name, fetchBenefits, id, colors } = useTheme();
  const { updateProfile } = useProfile();

  const from = (location.state as { from?: Location } | null)?.from;

  const formSchema = z.object({
    cpf: z.string(),
  });

  const methods = useForm({
    resolver: zodResolver(formSchema),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = methods;

  const loginMutation = useLoginExClient({
    onSuccess() {
      updateProfile({});
      navigate(from ? `${from.pathname}${from.search}` : '/', { replace: true });
    },
    onError(error) {
      toast({ title: 'Oops!', description: error, status: 'error' });
    },
  });

  const message = 'Faça login com um CPF ';

  return (
    <VStack w={'100%'} align={'flex-start'} spacing={4}>
      <SectionTitle display={'flex'} gap={1} flexDir="row" fontSize={14} fontWeight={600}>
        <Text fontSize={14}>
          {message}
          <span
            style={{
              color: colors.primaryColor,
            }}
          >{` ${name}`}</span>
        </Text>
      </SectionTitle>
      <Heading fontWeight={700} letterSpacing={'-0.045em'} fontFamily={'Glory'} fontSize={'36px'}>
        Login
      </Heading>
      <form
        onSubmit={handleSubmit(({ cpf }) => {
          if (validarCPF(cpf) || validarCNPJ(cpf)) {
            loginMutation.mutate({ cpf: masks.unmask(cpf) });
          } else {
            toast({ title: 'Erro', description: 'Por favor, CPF/CNPJ válido.', status: 'error' });
          }
        })}
        style={{ width: '100%' }}
      >
        <VStack w={'100%'} spacing={7}>
          <VStack w={'100%'} spacing={4}>
            <Input control={control} name="cpf" mask="document" label={'CPF/CNPJ'} autoComplete="off" />
          </VStack>
          <ButtonC
            alignSelf={'flex-end'}
            variant={'link'}
            onClick={() => {
              toast({
                title: 'Oops!',
                description: 'Por favor, entre em contato com o suporte para recuperar sua senha.',
                status: 'error',
              });
            }}
            color={colors.primaryColor}
          >
            <Heading fontWeight={500} fontSize={'16px'}>
              Esqueci minha senha
            </Heading>
          </ButtonC>

          <Button type="submit" isLoading={loginMutation.isLoading}>
            ENTRAR
          </Button>
          <Link
            onClick={() => {
              setExClient && setExClient(false);
            }}
            margin={'auto'}
            color={colors.primaryColor}
          >
            Voltar
          </Link>
          <Text
            color="#747474"
            margin="auto"
            textAlign={'center'}
            alignItems={'center'}
            gap={1}
            fontSize={14}
            fontWeight={400}
          >
            Está com dificuldade?{' '}
            <span onClick={() => navigate('/contato')} style={{ cursor: 'pointer', color: colors.primaryColor }}>
              Clique aqui
            </span>
            , entre em contato conosco.
          </Text>
        </VStack>
      </form>
      <Footer />
      <Spacer
        marginBottom={{
          base: '50px',
          md: '0px',
        }}
      />
    </VStack>
  );
}
